import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoCamera = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Camera</title>
    <path
      d="M29.57 22.858a3.429 3.429 0 0 1-3.428 3.43H7.853a3.419 3.419 0 0 1-3.422-3.408c-.01-3.436-.002-6.872.002-10.308a3.432 3.432 0 0 1 3.431-3.429h2.203c.764 0 1.478-.382 1.902-1.018l.928-1.392a2.286 2.286 0 0 1 1.902-1.018h4.408c.764 0 1.478.382 1.902 1.018l.928 1.392a2.286 2.286 0 0 0 1.902 1.018h2.203a3.429 3.429 0 0 1 3.429 3.43v10.285Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.997 21.714a4.571 4.571 0 1 0 0-9.142 4.571 4.571 0 0 0 0 9.142Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoCamera;
